.accepted{color:#2ebb54}.requested,.pending{color:#ffac45}
/*# sourceMappingURL=report-contact-status-cell-viewer.component-QBIIV4H2.css.map */
